var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuntGroupsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Hunt_Groups_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hunt_Groups_Active",
    "data-name": "Hunt Groups_Active",
    clipPath: "url(#clip-Hunt_Groups_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hunt_Groups",
    "data-name": "Hunt Groups",
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_58",
    "data-name": "Subtraction 58",
    d: "M-578.636-787.648h-2.232a.479.479,0,0,1-.479-.479h-.6a.48.48,0,0,1-.479.479h-.359a.479.479,0,0,1-.479-.479h-.673a.48.48,0,0,1-.479.479h-2.011a1.462,1.462,0,0,1-1.461-1.46V-791.1h-6.656a1.462,1.462,0,0,1-1.461-1.46v-2.083a1.018,1.018,0,0,1,.024-.275,4.422,4.422,0,0,1,4.345-3.591h3.352a4.428,4.428,0,0,1,4.045,2.63,5.063,5.063,0,0,1,1.318-.175h3.866a5.038,5.038,0,0,1,1.285.167,4.429,4.429,0,0,1,4.042-2.622h3.352a4.423,4.423,0,0,1,4.345,3.591,1.959,1.959,0,0,1,.024.275v2.083a1.462,1.462,0,0,1-1.461,1.46h-1.777l0,0,0,0-.018-.038-.008-.016-.006-.011-.011-.022-.01-.02-.014-.028,0,0-.019-.036,0,0-.008-.015-.017-.031,0,0a5.037,5.037,0,0,0-3.854-2.578,4.973,4.973,0,0,0-.554-.031,5.018,5.018,0,0,0-1.419.2,5.054,5.054,0,0,0-3.609,4.824c0,.02,0,.039,0,.058v.078c0,.017,0,.034,0,.051v.009c0,.018,0,.036,0,.055v.015q0,.027,0,.055v.006l0,.05v.015q0,.027,0,.054v.011l0,.049v.01c0,.019,0,.038.006.056v.009q.007.06.015.119c.021.147.047.292.08.433l.014.061.013.052,0,.016h0ZM-581-796.784a3.967,3.967,0,0,1-3.963-3.962A3.967,3.967,0,0,1-581-804.708a3.967,3.967,0,0,1,3.962,3.963A3.966,3.966,0,0,1-581-796.784Zm8.954-2.226a3.5,3.5,0,0,1-3.5-3.5,3.5,3.5,0,0,1,3.5-3.5,3.5,3.5,0,0,1,3.5,3.5A3.5,3.5,0,0,1-572.045-799.009Zm-17.909,0a3.5,3.5,0,0,1-3.5-3.5,3.5,3.5,0,0,1,3.5-3.5,3.5,3.5,0,0,1,3.5,3.5A3.5,3.5,0,0,1-589.955-799.009Z",
    transform: "translate(596 806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127",
    transform: "translate(16.715 11.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    "data-name": "Group 2125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4671",
    "data-name": "Path 4671",
    d: "M22.98,27.275a5.527,5.527,0,0,1-5.052-3.292,5.517,5.517,0,0,1,2.813-7.266,5.521,5.521,0,0,1,7.266,2.813,5.5,5.5,0,0,1-5.028,7.733Zm-.012-10.067a4.56,4.56,0,1,0,4.166,2.717h0A4.561,4.561,0,0,0,22.968,17.208Z",
    transform: "translate(-17.453 -16.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_60",
    "data-name": "Subtraction 60",
    d: "M-611.123-811a.479.479,0,0,1-.479-.479v-1.295a1.592,1.592,0,0,0,.479.073,1.593,1.593,0,0,0,.479-.073v1.295A.479.479,0,0,1-611.123-811Zm-.48-4.811h0V-817.1a.479.479,0,0,1,.479-.479.479.479,0,0,1,.479.479v1.281a1.637,1.637,0,0,0-.479-.072,1.592,1.592,0,0,0-.479.073Z",
    transform: "translate(616.639 819.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_59",
    "data-name": "Subtraction 59",
    d: "M-606.622-815.505h-1.294a1.591,1.591,0,0,0,.073-.479,1.591,1.591,0,0,0-.073-.479h1.294a.479.479,0,0,1,.479.479A.479.479,0,0,1-606.622-815.505Zm-4.332,0h-1.282a.479.479,0,0,1-.479-.479.479.479,0,0,1,.479-.479h1.282a1.587,1.587,0,0,0-.073.479,1.59,1.59,0,0,0,.073.478Z",
    transform: "translate(614.951 821.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    "data-name": "Group 2126",
    transform: "translate(3.433 3.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4674",
    "data-name": "Path 4674",
    d: "M22.4,23.276a2.083,2.083,0,1,1,2.083-2.083A2.084,2.084,0,0,1,22.4,23.276Zm0-3.2a1.113,1.113,0,1,0,1.113,1.113A1.119,1.119,0,0,0,22.4,20.08Z",
    transform: "translate(-20.32 -19.11)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuntGroupsActive);
export default __webpack_public_path__ + "static/media/Hunt_Groups_Active.1639fce3585670299048e07e75d76482.svg";
export { ForwardRef as ReactComponent };